var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('pills-select',{attrs:{"class-name":"pills-select-single","placeholder":_vm.placeholderToUse,"options":_vm.options,"disabled":_vm.disabled,"value":_vm.valueAsArray,"close-on-select":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }